import { ALERT_TYPES } from '../views/client-connect-v2/constants.js';

export const MEDIA_ID = {
	FLYER: 1,
	SOCIAL_MEDIA: 2,
	EMAIL: 3,
	VIDEO: 4,
	POWERPOINT: 5,
	PRICING_FLYER: 6,
};

export const AUDIENCE_ID = {
	BORROWER: 1,
	REAL_ESTATE_AGENT: 2,
	BUILDER_CONTRACTOR: 8,
	LOAN_OFFICER: 9,
	TITLE: 10,
	AMC: 11,
	CPA: 12,
	INSURANCE_AGENTS: 13,
	FINANCIAL_ADVISOR: 14,
	DIVORCE_ATTORNEY: 15,
};

export const CAMPAIGN_ID = {
	THREE_PERCENT_DOWN: '1',
	FHA: '19',
	PRESENTATIONS: '43',
	PRICING_SCENARIO_FLYER: '52',
	[ALERT_TYPES.BIRTHDAY]: '45',
	[ALERT_TYPES.RATE]: '51',
	[ALERT_TYPES.CREDIT]: '46',
	[ALERT_TYPES.UNITE]: '47',
	[ALERT_TYPES.UCONNECT]: '49',
	[ALERT_TYPES.MI_DROP_ELIGIBLE]: '50',
	[ALERT_TYPES.NEW_LISTING]: '48',
	[ALERT_TYPES.LOAN_ANNIVERSARY]: '44',
	[ALERT_TYPES.REVIEW_ME]: '97',
};

export const MEDIA_TYPE_OPTIONS = {
	//FLYER: 1
	1: {
		image: [0, 1, 12],
		nonImage: [4, 5, 6, 7, 10, 13],
		general: [0, 1, 4, 5, 6, 7, 10, 13],
	},
	//EMAIL: 3
	3: { general: [0, 1, 4, 5, 6, 7, 10, 11, 13] },
	//VIDEO: 4
	4: { general: [0, 1, 4, 5, 6, 7, 10, 13] },
	//PRICING_FLYER: 6
	6: {
		image: [0, 1, 12],
		nonImage: [4, 5, 6, 7, 10],
		general: [0, 1, 4, 5, 6, 7, 10],
	},
};

// CampaignId	Name
// 1	3% Down
// 2	100% Gift
// 3	Appraisal Waiver
// 4	ARMs
// 5	Blink
// 6	Bragging
// 7	Buy vs. Rent
// 8	Client Loyalty
// 9	Come home to the experts
// 10	Condos
// 11	Construction
// 12	Delayed Financing
// 13	Divorce
// 14	Doc-Less
// 15	Doctor's Loans
// 16	Educational
// 17	Elite
// 18	Escrow Waivers
// 19	FHA
// 20	Flex Term
// 21	High Balance NTWD
// 22	Holidays
// 23	Jumbo
// 24	Loan Limit
// 25	Miscellaneous
// 26	Mortgage Insurance
// 27	Power to the Processor
// 28	Purchases
// 29	Recruiting
// 30	Refinance
// 31	Review Me
// 32	Technology
// 33	TRID
// 34	UClose
// 49	UConnect
// 36	USDA
// 37	UTrack
// 38	VA
// 39	Virtual E-Closing
// 40	We’re Brokers. We’re Better.
// 41	Wholesale vs Retail
// 42	Winter Campaigns
// 43	Presentations
// 44	Loan Anniversary
// 45	Birthday
// 46	Credit Watch
// 47	Equity Watch (aka Unite)
// 48	New Listing
// 49	Market Watch
// 50	MI Drop Eligible
// 51	Rate Watch
// 52	Pricing Scenario Flyer
